<template>
  <main class="main-content">
    <div class="d-flex justify-content-center height" v-if="materials==null || properties==null || project==null">
      <div class="spinner-border text-primary">
        <span class="sr-only">در حال بارگذاری ...</span>
      </div>
    </div>
    <div v-else>
        <div class="row mx-1">
          <div class="col-sm-6">
              <h4>عنوان پروژه :  {{project.name}}</h4><br>
              <h5>نام مشتری :  {{project.customer.name}}</h5><br>
              <address>
                  <strong>کد ملی :  {{project.customer.identification}}</strong><br><br>
                  <strong> موبایل اول :</strong>  {{ project.customer.mobile }}
                  <br><br>
                  <strong> موبایل دوم :</strong>  {{ project.customer.mobile2 }}
                  <br><br>
                  <strong> تلفن ثابت :</strong>  {{ project.customer.phone }} <br><br>
                  <strong> آدرس ایمیل :</strong>  {{ project.customer.email }}
              </address>
          </div>
          <div class="col-sm-6 text-left">
              <h4>کد پروژه : {{project.code}}</h4><br>
              <p>
                  <span><strong>آدرس :</strong>    {{ project.address }}</span><br><br>
                  <span><strong>شیوه آشنایی :</strong>    {{project.introduction}}</span><br><br>
                  <span class="rtl"><strong>تاریخ ثبت پروژه :</strong>  {{project.date}}</span><br><br>
                  <span><strong> مدیر پروژه :</strong>
                      {{project.manager.name}}
                  </span><br><br>
                   <span><strong> بازدیدکننده :</strong>
                      {{project.visitor.name}}
                  </span><br><br>
                  <span><strong>وضعیت :</strong>
                      <button type="" class="btn  btn-sm ripple mr-1 mb-2 text-white" :style="{ backgroundColor: statuses[project.status].color }">
                          {{statuses[project.status].name}}</button>
                  </span><br><br>
              </p>
          </div>
        </div>
        <div class="table-responsive" >
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>نام</th>
                <th v-for="(property, index) in properties" :key="index" v-text="property.name"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(attr, attrIndex) in materials" :key="attrIndex">
                <td v-text="attrIndex+1"></td>
                <td v-text="attr.material.name">
                </td>
                <td v-for="(prop, index) in propertKeys" :key="index">
                  <p v-if="attr.detail">{{attr.detail[prop]}}</p>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>ردیف</th>
                <th>نام</th>
                <th v-for="(property, index) in properties" :key="index" v-text="property.name"></th>
              </tr>
            </tfoot>
          </table>
        </div>
    </div>
    <div class="text-right d-print-none">
      <hr class="m-t-b-50">
      <a @click="pdf_print" class="btn btn-success m-l-5 my-1">
        <i class="fa fa-print m-r-5"></i> چاپ
      </a>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-report',
  props: ['statuses', 'project', 'managerReport'],
  data () {
    return {
      materials: null,
      properties: null,
      propertKeys: null,
      pdf: null
    }
  },
  created () {
    this.$parent.startManagerReport()
  },
  mounted () {
    this.materials = this.managerReport.attributes
    this.properties = this.managerReport.properties
    this.propertKeys = this.managerReport.keys
  },
  methods: {
    pdf_print () {
      this.pdf = print()
    }
  }
}
</script>
